import { Card, CardContent, Grid, Typography } from "@mui/material";


function SummaryCard({ title, value }) {
  return (
    <Grid item xs={12} sm={6} md={2.4}>
      <Card className="summary-card">
        <CardContent className="content">
          <span className="summary-title">{title}</span>
          <span className="summary-value">{value}</span>
        </CardContent>
      </Card>
    </Grid>
  );
}

export default SummaryCard;
